//src/components/shared/CrudDialog.tsx
import { ReactNode, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface CrudDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  children: ReactNode;
  onSave: () => void | Promise<void>;
  saveLabel?: string;
}

export function CrudDialog({
  open,
  onOpenChange,
  title,
  description,
  children,
  onSave,
  saveLabel = "Salvar",
}: CrudDialogProps) {
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (saving) return;
    try {
      setSaving(true);
      await onSave();
      // ✅ só fecha se onSave não lançar erro
      onOpenChange(false);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="
          w-[min(980px,95vw)]
          max-w-none
          p-0
        "
      >
        {/* Header fixo */}
        <div className="p-6 pb-3">
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            {description && <DialogDescription>{description}</DialogDescription>}
          </DialogHeader>
        </div>

        {/* Conteúdo com scroll */}
        <div className="px-6 pb-2 max-h-[70vh] overflow-auto">
          <div className="space-y-4 py-2">{children}</div>
        </div>

        {/* Footer fixo */}
        <DialogFooter className="px-6 py-4 border-t">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={saving}
          >
            Cancelar
          </Button>

          <Button onClick={handleSave} disabled={saving}>
            {saving ? "Salvando..." : saveLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
